@if (!poll) {
  <app-spinner></app-spinner>
}

@if (poll) {
  <tyt-poll [poll]="poll" (voteChanged)="voteChanged($event)"></tyt-poll>
  <div class="view-all-section">
    <a routerLink="/polls">View all polls</a>
  </div>
  @if (enableComments) {
    @if (voted || closedEarlier) {
      <tyt-comments
        url="/polls/{{pollSlug}}"
        [identifier]="commentIdentifier"
        requirementType="registration"
      ></tyt-comments>
    }
    @if (!voted && !closedEarlier) {
      <h2>Comments</h2>
      <em>Vote first in order to see and post comments on this poll.</em>
      <br />
      <br />
    }
  }
}